import React  from 'react';
import PropTypes from 'prop-types';

const DataSourcesIcon = (props) => {
  const { width, height, isActive } = props;
  let color;
  if (isActive) {
    color = '#FF4200';
  }
  else {
    color = '#AEB2BF';
  }
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} fill="none" viewBox="0 0 24 22">
      <path fill={color} d="M23.607.204a1.01 1.01 0 0 0-.87-.17L12 2.962 1.263.034a1.007 1.007 0 0 0-.87.17C.146.394 0 .687 0 1v17a1 1 0 0 0 .737.965l11 3a1.022 1.022 0 0 0 .526 0l11-3A1 1 0 0 0 24 18V1c0-.312-.146-.605-.393-.795zM9.702 17.264l-5.93-1.618.526-1.93 5.93 1.617-.526 1.93zm0-4.492l-5.93-1.617.526-1.93 5.93 1.617-.526 1.93zm0-4.217l-5.93-1.617.526-1.93 5.93 1.617-.526 1.93zm4.596 8.708l-.526-1.93 5.93-1.617.526 1.93-5.93 1.617zm0-4.49l-.526-1.93 5.93-1.618.526 1.93-5.93 1.617zm0-4.218l-.526-1.93 5.93-1.617.526 1.93-5.93 1.617z"/>
    </svg>
  );
};

DataSourcesIcon.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
  isActive: PropTypes.bool,
};

DataSourcesIcon.defaultProps = {
  width: 24,
  height: 22,
  isActive: false,
};

export default DataSourcesIcon;
